import { RequestServerClass } from '@/util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam'; // post请求体转换方法

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class GetImgServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 根据id数组获取图片
  public getImg(opts: object) {
    const url = serverUrl + '/api/sysManage/sysFile?ids=' + opts.toString();
    return this.rSerivce.serverObj.get(url);
  }

  public getImgInfo(ids: string) {
    const url = serverUrl + '/api/sysManage/sysFile?ids=' + ids;
    return this.rSerivce.serverObj.get(url);
  }

  // 上传文件
  public putImg(opts: object) {
    const url = serverUrl + '/api/sysManage/sysFile';
    return this.rSerivce.serverObj.post(url, opts, { headers: { 'Content-Type': 'multipart/form-data' } });
  }
}
